const ai = {
  // General
  aiPowered: 'مدعوم بالذكاء الاصطناعي',
  generating: 'جاري التوليد...',
  regenerate: 'إعادة التوليد',
  apply: 'تطبيق',
  cancel: 'إلغاء',
  copy: 'نسخ',
  copied: 'تم النسخ',

  // Coming Soon
  comingSoon: 'قريباً',
  comingSoonDesc: 'هذه الميزة قيد التطوير وستكون متاحة قريباً',

  // Description Generator
  description: {
    title: 'مولد الوصف الذكي',
    subtitle: 'دع الذكاء الاصطناعي يكتب وصفاً احترافياً لعقارك',
    inputLabel: 'معلومات أساسية عن العقار',
    inputPlaceholder: 'اكتب ملاحظات عن العقار (الموقع، المميزات، القرب من الخدمات...)',
    generate: 'توليد الوصف',
    resultLabel: 'الوصف المقترح',
    toneLabel: 'أسلوب الكتابة',
    tones: {
      professional: 'احترافي',
      friendly: 'ودود',
      luxury: 'فاخر',
      simple: 'بسيط',
    },
    lengthLabel: 'طول الوصف',
    lengths: {
      short: 'قصير',
      medium: 'متوسط',
      long: 'طويل',
    },
    tips: {
      title: 'نصائح للحصول على أفضل وصف',
      tip1: 'اذكر الموقع والحي بالتفصيل',
      tip2: 'حدد المميزات الفريدة للعقار',
      tip3: 'اذكر القرب من المدارس والمساجد والخدمات',
      tip4: 'وضح مساحة العقار وعدد الغرف',
    },
  },

  // Title Improver
  title: {
    title: 'محسن العنوان',
    subtitle: 'حسّن عنوان إعلانك ليجذب المزيد من المشاهدات',
    currentTitle: 'العنوان الحالي',
    currentTitlePlaceholder: 'أدخل عنوان الإعلان الحالي',
    suggestions: 'العناوين المقترحة',
    improve: 'تحسين العنوان',
    tips: {
      title: 'نصائح لعنوان جذاب',
      tip1: 'اذكر نوع العقار والموقع',
      tip2: 'أضف ميزة مميزة (مسبح، حديقة، إطلالة)',
      tip3: 'حدد عدد الغرف إذا كان مميزاً',
      tip4: 'تجنب العناوين الطويلة جداً',
    },
  },

  // Price Suggestion
  price: {
    title: 'تقدير السعر الذكي',
    subtitle: 'احصل على تقدير للسعر العادل بناءً على بيانات السوق',
    estimate: 'السعر المقدر',
    range: 'النطاق السعري',
    low: 'أقل سعر',
    high: 'أعلى سعر',
    market: 'متوسط السوق',
    confidence: 'مستوى الثقة',
    factors: {
      title: 'العوامل المؤثرة في التقييم',
      location: 'الموقع',
      size: 'المساحة',
      age: 'عمر العقار',
      condition: 'حالة العقار',
      amenities: 'المميزات',
      market: 'ظروف السوق',
    },
    getSuggestion: 'احصل على التقدير',
    disclaimer: 'هذا التقدير استرشادي وقد يختلف السعر الفعلي بناءً على عوامل أخرى',
  },

  // Competition Analysis
  competition: {
    title: 'تحليل المنافسة',
    subtitle: 'اكتشف كيف يقارن عقارك بالعقارات المماثلة',
    analyze: 'تحليل المنافسة',
    similarListings: 'إعلانات مماثلة',
    priceComparison: 'مقارنة الأسعار',
    yourPrice: 'سعرك',
    averagePrice: 'متوسط السوق',
    recommendation: 'التوصية',
    metrics: {
      viewsAvg: 'متوسط المشاهدات',
      daysOnMarket: 'أيام في السوق',
      inquiriesAvg: 'متوسط الاستفسارات',
    },
  },

  // Best Time to Post
  bestTime: {
    title: 'أفضل وقت للنشر',
    subtitle: 'اختر الوقت الأمثل لنشر إعلانك',
    bestDays: 'أفضل الأيام',
    bestHours: 'أفضل الأوقات',
    recommendation: 'نوصي بالنشر',
    viewerActivity: 'نشاط المشاهدين',
    days: {
      sunday: 'الأحد',
      monday: 'الاثنين',
      tuesday: 'الثلاثاء',
      wednesday: 'الأربعاء',
      thursday: 'الخميس',
      friday: 'الجمعة',
      saturday: 'السبت',
    },
  },

  // AI Assistant Widget
  assistant: {
    title: 'المساعد الذكي',
    greeting: 'مرحباً! كيف يمكنني مساعدتك اليوم؟',
    placeholder: 'اكتب سؤالك هنا...',
    send: 'إرسال',
    suggestions: {
      title: 'اقتراحات',
      writeDescription: 'اكتب وصفاً لعقاري',
      suggestPrice: 'ما السعر المناسب؟',
      improveTitle: 'حسّن عنوان إعلاني',
      analyzMarket: 'حلل سوق المنطقة',
    },
  },

  // Error messages
  errors: {
    generateFailed: 'حدث خطأ أثناء التوليد، يرجى المحاولة مرة أخرى',
    inputRequired: 'يرجى إدخال معلومات العقار',
    networkError: 'خطأ في الاتصال، يرجى التحقق من الإنترنت',
  },
};

export default ai;
